import { ComponentConfig } from "@measured/puck";

export interface ImageProps {
  src: string;
  alt?: string;
  width?: number | string;
}

const Image = (props: ImageProps) => {
  return (
    <div style={{ maxWidth: props.width }}>
      <img style={{ width: "100%" }} src={props.src} alt={props.alt} />
    </div>
  );
};

export const PuckImage: ComponentConfig<ImageProps> = {
  label: "Image",
  fields: {
    src: {
      type: "text",
      label: "Source URL",
    },
    alt: {
      type: "text",
      label: "Alt Text",
    },
    width: {
      type: "text",
      label: "Width",
    },
  },
  render: (props) => <Image {...props} />,
};
